angular.module('b2bLoginApp')
    .service('sdMobileMenuService', function () {
        var openScope = null;
        var closeIcon = '<svg class="sd-mobile-close-icon" viewBox="0 0 40 40"><path class="close-x" d="M 10,10 L 30,30 M 30,10 L 10,30"></path></svg>';

        this.showCloseIcon = function (fixedOverlayScope) {
            var activeToggleElement = fixedOverlayScope.getActiveToggleElement();
            activeToggleElement.html(closeIcon);
        };

        this.showOriginalToggleIcon = function (fixedOverlayScope) {
            var activeToggleElement = fixedOverlayScope.getActiveToggleElement();
            activeToggleElement.html(fixedOverlayScope.getOriginalToggleElement());
        };

        this.close = function (fixedOverlayScope, element) {
            if (!openScope) {
                return;
            }

            element.removeClass('open');

            this.showOriginalToggleIcon(fixedOverlayScope);
        };

        this.open = function (fixedOverlayScope, element) {
            if (openScope && openScope !== fixedOverlayScope) {
                openScope.isOpen = false;
            }

            element.addClass('open');

            openScope = fixedOverlayScope;

            this.showCloseIcon(fixedOverlayScope);
        };
    })

    .controller('sdMobileMenuController', ["$scope", "$element", "sdMobileMenuService", function ($scope, $element, sdMobileMenuService) {
        var self = this,
            scope = $scope.$new()
        ;

        this.init = function () {
            scope.isOpen = false;
        };

        this.initToggleElement = function (element) {
            self.originalToggleElement = element.html();
            self.activeToggleElement = element;
        };

        this.toggle = function () {
            scope.isOpen = !scope.isOpen;
        };

        scope.$watch('isOpen', function (isOpen) {
            if (isOpen) {
                sdMobileMenuService.open(scope, $element);
            } else {
                sdMobileMenuService.close(scope, $element);
            }
        });

        scope.getOriginalToggleElement = function () {
            return self.originalToggleElement;
        };

        scope.getActiveToggleElement = function () {
            return self.activeToggleElement;
        };
    }])

    .directive('sdMobileMenu', function () {
        return {
            controller: 'sdMobileMenuController',
            link: function (scope, element, attrs, mobilemobileMenuCtrl) {
                mobilemobileMenuCtrl.init();
            }
        };
    })
    .directive('sdMobileMenuItems', function () {
        return {
            restrict: 'A',
            require: '?^sdMobileMenu',
            link: function (scope, element, attrs, mobileMenuCtrl) {

                var toggleMenu = function () {
                    scope.$apply(function () {
                        mobileMenuCtrl.toggle();
                    });

                };

                element.addClass('fixed-overlay-menu');
                element.find('a').on('click', toggleMenu);

                if (!mobileMenuCtrl.dropdownMenu) {
                    mobileMenuCtrl.dropdownMenu = element;
                }
            }
        };
    })
    .directive('sdMobileMenuToggle', function () {
        return {
            require: '?^sdMobileMenu',
            link: function link(scope, element, attrs, mobileMenuCtrl) {
                mobileMenuCtrl.initToggleElement(element);

                var toggleMenu = function (event) {
                    event.preventDefault();

                    scope.$apply(function () {
                        mobileMenuCtrl.toggle();
                    });

                };

                element.on('click', toggleMenu);
            }
        };
    });
